module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bc6bc02e0931cc10c6507a78b12ae02e.png";